export default __webpack_public_path__ + "f1d54d734ec9a3c3bbadf2808fdf41c3.png";